import React from "react";
import { motion } from "framer-motion";
import {
    Row,
    Col,
    Card,
    CardBody
} from "reactstrap";
import { connect } from 'react-redux';
import { closeProfile } from '../../../redux/actions/admin.action';
import discordNoLogo from "assets/img/discordNoLogo.png";

const UserProfile = (props) => {
    function formatTimer(laps) {
        let days = Math.floor(laps / (3600 * 24));
        laps %= (3600 * 24);
        let hours = Math.floor(laps / 3600);
        laps %= 3600;
        let minutes = Math.floor(laps / 60);
        if (days)
            return formatZero(days) + 'd ' + formatZero(hours) + 'h ' + formatZero(minutes) + 'm';
        return formatZero(hours) + 'h ' + formatZero(minutes) + 'm';
    }
    const formatZero = (value) => {
        if (value > 9) return value;
        else return `0${value}`;
    };
    const getPaymentsData = (p) => {
        return p.payments.map((data, key) => {
          var date = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(data.creation);
          return (
            <Card className="cardPayment">
                <CardBody className="paymentLine">
                  <Row>
                    <Col xs="4">
                      {date}
                    </Col>
                    <Col xs="4" className="text-center">
                      {`${data.mcGross} ${data.mcCurrency}`}
                    </Col>
                    <Col xs="4" className="text-center">
                      {`#${p.id}`}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
          );
        });
    };
    var date = props.userProfile?.instanceLastAlive ? new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(props.userProfile.instanceLastAlive*1000) : '/';
    return (
            <div className="userProfileBody">
                    <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.2 } }}>
                        <div className="back"><i className="userProfile-back tim-icons icon-double-left" onClick={() => props.closeProfile()}/></div>
                    </motion.div>
                    <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                        <div className="title">User information</div>
                    </motion.div>
                    <Row className="userProfileBodyBlock">
                        <Col xs="6">
                            <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.8 } }}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col xs="4">
                                                <img className="userAvatar" alt="avatar" src={props.userProfile?.avatar ? `https://cdn.discordapp.com/avatars/${props.userProfile.avatar}.png?size=128` : discordNoLogo} onError={(e)=>{e.target.onerror = null; e.target.src = discordNoLogo}}/>
                                            </Col>
                                            <Col xs="8">
                                                <Row>
                                                    <Col xs="6" className="c-white">
                                                        Pseudo
                                                    </Col>
                                                    <Col xs="6" className="c-white">
                                                        {props.userProfile?.pseudo}
                                                    </Col>
                                                    <Col xs="6" className="c-white">
                                                        Plan
                                                    </Col>
                                                    <Col xs="6" className="c-white">
                                                        {props.userProfile?.vip.plan}
                                                    </Col>
                                                    {props.userProfile?.vip.remain > 0 && <Col xs="6" className="c-white">
                                                        Remain
                                                    </Col>}
                                                    {props.userProfile?.vip.remain > 0 && <Col xs="6" className="c-white">
                                                        {formatTimer(props.userProfile?.vip.remain)}
                                                    </Col>}
                                                    <Col xs="6" className="c-white">
                                                        Steam
                                                    </Col>
                                                    <Col xs="6" className="c-white selectable" onClick={() => window.open(`https://steamcommunity.com/profiles/${props.userProfile.sid}`)}>
                                                        {props.userProfile?.sid}
                                                    </Col>
                                                    <Col xs="6" className="c-white">
                                                        Instance last alive
                                                    </Col>
                                                    <Col xs="6" className="c-white">
                                                        {date}
                                                    </Col>
                                                    <Col xs="6" className="c-white">
                                                        Server connected
                                                    </Col>
                                                    <Col xs="6" className="c-white">
                                                        {props.userProfile?.server ? props.userProfile.server : '/'}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </motion.div>
                        </Col>
                        <Col xs="6">
                            <motion.div initial={{ opacity: 0, x: 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.8 } }}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col xs="4">
                                                Btns admin
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </motion.div>
                        </Col>
                    </Row>
                    <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                        <div className="title">Payment history</div>
                    </motion.div>
                    <motion.div initial={{ opacity: 0, x: 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.8 } }}>
                        <Card className="userProfileBodyBlock">
                            <CardBody>
                            {props.userProfile?.payments && props.userProfile.payments.length ? props.userProfile.payments.map(p => {
                                return(getPaymentsData(p))
                            }) : <div> No history</div>}
                            </CardBody>
                        </Card>
                    </motion.div>
                    <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                        <div className="title">User logs</div>
                    </motion.div>
                    <motion.div initial={{ opacity: 0, x: 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.8 } }}>
                        <Card className="userProfileBodyBlock">
                            <CardBody>
                                User logs
                            </CardBody>
                        </Card>
                    </motion.div>
                    <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                        <div className="title">User devices</div>
                    </motion.div>
            </div>
    );
};

const mapDispatchToProps = {
    closeProfile
};

const mapStateToProps = (state) => {
    const { userProfile } = state.admin.users;
    return { userProfile };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);